import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import Dashboard from './admin/python-sentiment-analysis/dashboard/Dashboard'; // Correct path



const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));
const UserRoute = lazy(() => import('./UserRoute'));
const CommonDrawerComponent = lazy(() => import('../components/drawer'));

const Login = lazy(() => import('../pages/admin/python-sentiment-analysis/login/login')); // Updated path

const AppRoute = () => {
    return (
        <>
            <Suspense fallback={<LoaderText />}>
                <Routes>
                    <Route path='/login' element={<Login />} /> {/* Add this route for login */}
                    <Route path='/admin/*' element={<AdminRoute />} />
                    <Route path="/dashboard" element={<Dashboard />} />

                    <Route path='/' element={<Navigate to="/admin" />} /> {/* Redirect to admin */}
                    {/* <Route path="/callback" element={<CallbackHandler />} /> Main auth flow */}

                    {/* You can add more routes here */}
                </Routes>
            </Suspense>
            <CommonDrawerComponent />
        </>
    );
};

export default AppRoute;
